import { FormattedMessage } from 'react-intl';

import { Button } from '@sorare/core/src/atoms/buttons/Button/index.tsx';
import { NoCards } from '@sorare/core/src/atoms/icons/NoCards.tsx';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineM } from '@sorare/core/src/atoms/typography/index.tsx';

type Props = {
  to?: string;
};

export const LineupsEmptyState = ({ to }: Props) => (
  <Vertical center gap={2} style={{ minHeight: '500px' }}>
    <NoCards size={6} />
    <HeadlineM>
      <FormattedMessage defaultMessage="No lineups entered" />
    </HeadlineM>
    {to ? (
      <Button to={to} size="large" color="primary">
        <FormattedMessage defaultMessage="Enter lineups" />
      </Button>
    ) : null}
  </Vertical>
);
